<template>
  <div v-if="cookieAccept">
    <el-dialog custom-class="quick-register-dialog" :visible.sync="show" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="onClose" top="0">
      <img class="logo is-desktop" :src="`assets/Logo/HomeQuickRegister.png` | ossPath" alt="">
      <img class="logo is-mobile" :src="`assets/Logo/HomeQuickRegister_mobile.png` | ossPath" alt="">
      <div class="form-box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <div class="tip">诚邀您加入 Onitsukatiger,享受会员权益</div>
          <div class="tip">注册新会员即送 1000 积分</div>
          <div class="input-item">
            <el-form-item prop="mobile" class="common-ipt">
              <el-input v-model.trim="ruleForm.mobile" minlength="11" maxlength="11" placeholder="请输入您的手机号"></el-input>
            </el-form-item>
          </div>
          <div class="input-item">
            <el-form-item prop="code" class="item-left">
              <el-input v-model.trim="ruleForm.code" class="verify-input" placeholder="请输入手机验证码"></el-input>
            </el-form-item>
            <el-button class="send-btn" :disabled="disableSendSMS" @click="sendSMS">发送验证码{{
              `${countdown ? "(" + countdown + "s)" : ""}`
            }}</el-button>
          </div>
          <div class="input-item">
            <el-form-item class="status" prop="userCheck">
              <i class="iconfont" @click="ruleForm.userCheck = !ruleForm.userCheck">{{ ruleForm.userCheck ? "&#xedaf;" :
                "&#xec58;" }}</i>
              <span @click="ruleForm.userCheck = !ruleForm.userCheck" :class="[ruleForm.userCheck ? 'selected' : '']">
                我已仔细阅读并同意<a
              :href="MemberShipRules" target="_blank">会员规则
            </a>和<router-link to="/cms/privacy-policy" target="_blank">隐私政策</router-link>。</span>
            </el-form-item>
          </div>
        </el-form>
        <el-button class="login-btn" :disabled="disableSubmit" @click="submitForm('ruleForm')">注册/登录</el-button>
      </div>
    </el-dialog>
    <el-dialog custom-class="quick-register-success-dialog" :visible.sync="successShow" :close-on-click-modal="false"
      :close-on-press-escape="false" top="0">
      <div class="title">注册成功</div>
      <div class="sub-title">完善个人信息可额外获得 30 积分<br />
        手机扫码完成个人信息完善</div>
      <img class="wx-vip-center-code" src="https://assetsprod.onitsukatiger.com//assets/wechat/usergw/user.png"
        alt="Member_Benefits1" />
    </el-dialog>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
export default {
  data() {
    var validateUsercheck = (rule, value, callback) => {
      if (value === false) {
        callback(new Error("请阅读安全隐私政策"));
      } else {
        callback();
      }
    };

    return {
      show: false,
      successShow: false,
      countdown: 0,
      ruleForm: {
        mobile: "",
        code: "",
        userCheck: false,
      },
      rules: {
        mobile: [
          {
            validator(fieldRule, value, callback) {
              if (!value) {
                callback(new Error("请输入手机号"));
              } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        userCheck: [{ validator: validateUsercheck, trigger: "blur" }],
      }
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    cookieAccept() {
      const cookie = this.$store.state.cookieAccept;
      const privacy = this.$store.state.privacyAccept;
      return (cookie && cookie.accept) && (privacy && privacy.accept);
    },
    disableSendSMS() {
      if (this.countdown) return true;
      let { mobile, } = this.ruleForm;
      if (/^1[3456789]\d{9}$/.test(mobile)) {
        return false;
      }
      return true;
    },
    disableSubmit() {
      let { mobile, code, userCheck } = this.ruleForm;
      if (
        /^1[3456789]\d{9}$/.test(mobile) &&
        code &&
        userCheck
      ) {
        return false;
      }
      return true;
    },
    MemberShipRules() {
      return this.$store.state.commonConfig['MemberShip-Rules'] || 'https://statics.maiscrm.com/663c66976dc8b037dc6d0783/modules/retail/o_1j2lp85801ac61nup131sgtqp40/%E3%80%90FINAL%E3%80%91Onitsuka%20Tiger%20%E4%BC%9A%E5%91%98%E8%A7%84%E5%88%99V2025.8.15-%20%E5%85%A8%E6%B8%A0%E9%81%93.pdf';
    },
  },
  mounted() {
    let quickRegisterHide = localStorage.getItem('quickRegisterHide');
    this.show = !this.isLogin && (!quickRegisterHide || (new Date().getTime() - quickRegisterHide > 86400 * 1000));
  },
  methods: {
    onClose() {
      localStorage.setItem('quickRegisterHide', new Date().getTime())
    },
    // 发送手机验证码短信
    sendSMS() {
      api[types.QUICK_REGISTER_SMS_CODE]({
        mobile: this.ruleForm.mobile,
      })
        .then((res) => {
          if (res?.code == 1) {
            this.runCountdown(60, (time) => {
              this.countdown = time;
            });
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    // 提交数据
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { mobile, code } = this.ruleForm;
          api[types.QUICK_REGISTER_BY_MOBILE]({ mobile, code })
            .then((res) => {
              if (res.data?.token) {
                this.$store.commit(types.LOGIN, res.data?.token);
                this.$store.dispatch(types.GET_PROFILE);
                this.show = false;
                if (res.data.type === 'register') {
                  this.successShow = true;
                  window.gtag("event", "account_registration", {
                    send_to: process.env?.VUE_APP_GA4,
                  });
                } else if (res.data.type === 'login') {
                  this.$message({
                    message: '您已登陆成功',
                    type: "success"
                  })
                  window?.gtag("event", "normal_login", {
                    send_to: process.env?.VUE_APP_GA4,
                    event_category: "normal login",
                    event_label: window.location.href,
                    login_type: "verify code",
                  });
                }
              } else {
                console.warn(res);
                this.$message({
                  message: res?.message,
                  type: "warning",
                });
              }
            })
            .catch((err) => {
              console.warn(err);
            });
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang='scss' scoped>
%ot-dialog {
  top: 50%;
  transform: translateY(-50%);

  .is-desktop {
    display: block;
  }

  .is-mobile {
    display: none;
  }

  .el-dialog__header {
    padding: 0;

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;

      .el-icon-close {
        font-size: 24px;
        color: #000 !important;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .is-desktop {
      display: none;
    }

    .is-mobile {
      display: block;
    }

    .el-dialog__header {
      padding: 0;

      .el-dialog__headerbtn {
        top: 16px;
        right: 16px;
      }
    }
  }
}

::v-deep .quick-register-dialog {
  width: 800px;
  height: 534px;
  @extend %ot-dialog;

  .el-dialog__body {
    display: flex;
    padding: 0;
    width: 100%;
    height: 100%;
    color: #212322;
    font-family: Matter, Noto Sans CJK SC;

    ::placeholder {
      color: #666;
      font-family: Noto Sans CJK SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }

    .logo {
      object-fit: cover;
      width: 50%;
      height: 100%;
    }

    .form-box {
      flex: 1;
      padding: 80px 40px 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;

      .tip {
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;

        &+.tip {
          margin-top: 8px;
        }
      }

      .input-item {
        display: flex;
        margin-top: 32px;

        &+.input-item {
          margin-top: 24px;
        }

        .el-form-item {
          margin-bottom: 0;
          width: 100%;
        }

        .el-input__inner {
          font-family: Matter, Noto Sans CJK SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 38px;
          height: 38px;
          padding: 0 12px;
        }


        .verify-input {
          margin-right: 10px;
        }

        .item-left {
          flex: 1;
        }

        .send-btn {

          background: #E7E7E7;
          color: #666;
          font-size: 14px;
          padding: 0 12px;
          width: 127px;
          height: 38px;
          cursor: pointer;
          margin-left: 8px;
          border-radius: 0;
          border: none;
          font-family: Matter, Noto Sans CJK SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;

          &[disabled] {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }

      .status {

        .el-form-item__content {
          cursor: pointer;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          display: flex;
          align-items: center;

          .iconfont {
            margin-right: 8px;
          }

          span {
            &.selected {
              color: #000;
            }

            a {
              color: #212322;
              font-family: Matter, Noto Sans CJK SC;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px;
              text-decoration: underline;
            }
          }
        }
      }

      .login-btn {
        width: 100%;
        height: 40px;
        color: #fff;
        background: #7f0019;
        font-size: 14px;

        &[disabled] {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
    }

  }
}

::v-deep .quick-register-success-dialog {
  width: 600px;
  padding: 40px 0;
  @extend %ot-dialog;

  .el-dialog__body {
    text-align: center;
    padding: 0 16px;

    .title {
      color: #212322;
      text-align: center;
      font-family: FZLanTingHeiS-R-GB;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    .sub-title {
      padding: 24px 0 32px;
      color: #666;
      text-align: center;
      font-family: Matter, FZLanTingHeiS-R-GB;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    .wx-vip-center-code {
      margin: 20px auto;
      width: 184px;
      height: 184px;
    }
  }
}

@media only screen and (max-width: 768px) {
  ::v-deep .quick-register-dialog {
    width: calc(100% - 48px);
    height: 558px;

    .el-dialog__header {
      .el-dialog__headerbtn {
        .el-icon-close {
          color: #fff !important;
        }
      }
    }

    .el-dialog__body {
      display: flex;
      flex-direction: column;

      .logo {
        width: 100%;
        height: 245px;
      }

      .form-box {
        padding: 20px 16px 32px;

        .tip {
          display: none;
        }

        .input-item {
          margin-top: 0;

          &+.input-item {
            margin-top: 24px;
          }
        }
      }
    }
  }

  ::v-deep .quick-register-success-dialog {
    width: calc(100% - 48px);
    padding: 24px 0;

    .el-dialog__body {
      .wx-vip-center-code {
        margin: 20px auto;
        width: 144px;
        height: 144px;
      }
    }
  }
}
</style>